/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import DashboardIcon from '@material-ui/icons/DashboardOutlined';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import AssignmentInd from '@material-ui/icons/AssignmentInd';
// import Layers from '@material-ui/icons/Layers';
import CardMembershipIcon from '@material-ui/icons/CardMembership';
import StyleIcon from '@material-ui/icons/Style';
import EventAvailable from '@material-ui/icons/EventAvailable';
import ForumIcon from '@material-ui/icons/Forum';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import PeopleIcon from '@material-ui/icons/People';
//import InfoIcon from '@material-ui/icons/Info';

export default [
  {
    subheader: 'Management',
    items: [
      {
        title: 'Dashboard',
        href: '/dashboard',
        icon: DashboardIcon
      },
      {
        title: 'Candidates',
        href: '/candidates',
        icon: AssignmentInd
      },
      {
        title: 'Clients',
        href: '/clients',
        icon: AssignmentInd
      },
      {
        title: 'Competencies',
        href: '/competencies',
        icon: CardMembershipIcon
      },
      {
        title: 'Mentors',
        href: '/mentors',
        icon: PeopleIcon
      }
      // {
      //   title: 'Client Managers',
      //   href: '/managers',
      //   icon: AssignmentInd
      // }
    ]
  },
  {
    subheader: 'Courses',
    items: [
      {
        title: 'Courses',
        href: '/courses',
        icon: LibraryBooks,
        items: [
          {
            title: 'Courses',
            href: '/courses'
          },
          {
            title: 'Modules',
            href: '/modules'
          },
          {
            title: 'Tests',
            href: '/tests'
          },
          {
            title: 'Questions',
            href: '/questions'
          },
          {
            title: 'Lessons',
            href: '/lessons'
          }
        ]
      },
      {
        title: 'Certificate Types',
        href: '/certificateTypes',
        icon: CardMembershipIcon
      },
      {
        title: 'Categories',
        href: '/categories',
        icon: CardMembershipIcon
      },
      {
        title: 'Secondary Categories',
        href: '/secondarycategories',
        icon: CardMembershipIcon
      },
      {
        title: 'Tutors',
        href: '/tutors',
        icon: AssignmentInd
      },
      // {
      //   title: 'Popular Courses',
      //   href: '/popular-courses',
      //   icon: Layers
      // },
      {
        title: 'Tags',
        href: '/tags',
        icon: StyleIcon
      },
      {
        title: 'Events',
        href: '/socialEvents',
        icon: EventAvailable
      },
      {
        title: 'Character & Suitability',
        href: '/characterSuitability',
        icon: PermIdentityIcon
      },
      {
        title: 'Competency Plus',
        href: '/advice',
        icon: ForumIcon //InfoIcon
      }
    ]
  },
  {
    subheader: 'Admin Settings',
    items: [
      {
        title: 'Admins',
        href: '/admins',
        icon: SupervisorAccountIcon
      }
    ]
  }
];
